import { IncomingMessage, type IncomingMessageProps } from './IncomingMessage'

type RespondingMessageProps = Pick<IncomingMessageProps, 'owner'>

function RespondingMessage({ owner }: RespondingMessageProps) {
  return (
    <IncomingMessage owner={owner}>
      <div className="flex items-center gap-0.5">
        <span className="animate-bounce [animation-delay:-0.3s]">.</span>
        <span className="animate-bounce [animation-delay:-0.15s]">.</span>
        <span className="animate-bounce">.</span>
      </div>
    </IncomingMessage>
  )
}

export default RespondingMessage
